import { TaxPayerType } from './types.ts'

interface TaxPayerProps {
  tax_payer: TaxPayerType
}

export default function TaxPayer({ tax_payer }: TaxPayerProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {tax_payer.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Full name:</strong>
        {tax_payer.full_name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {(tax_payer.community_name || tax_payer.community_id)?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Type de contribuable:</strong>
        {(tax_payer.tax_payer_type_name || tax_payer.tax_payer_type_id)?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Zone:</strong>
        {(tax_payer.area_name || tax_payer.area_id)?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Adresse:</strong>
        {tax_payer.address?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Lat:</strong>
        {tax_payer.lat?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Lng:</strong>
        {tax_payer.lng?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Rccm:</strong>
        {tax_payer.rccm?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nif:</strong>
        {tax_payer.nif?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Téléphone:</strong>
        {tax_payer.phone?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Email:</strong>
        {tax_payer.email?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax_payer.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Offline uuid:</strong>
        {tax_payer.offline_uuid?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Verified:</strong>
        {tax_payer.verified?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">User:</strong>
        {tax_payer.user_id?.toString()}
      </p>
    </div>
  )
}
